import {svgIconWrapper} from '../svg-icon-wrapper';

import HouseRegular from './house-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <HouseRegular {...props} />;
}
SvgComponent.iconName = 'houseRegular';

export const HouseRegularIcon = svgIconWrapper(SvgComponent);
